import { createContext } from 'react';

export interface PopoverContextType {
  closePopover: () => void;
}

export const PopoverContext = createContext<PopoverContextType>({
  closePopover: () => {},
});
